import Table, { ColumnsType } from "antd/lib/table";
import React from "react";

export interface PedidoResumen {
  Fecha: string;
  R: string;
  Prov: string;
  Cant: number;
  Boni: number;
  Des: number;
  Costo: number;
}

interface Props {
  data: PedidoResumen[];
  loading?: boolean;
}

// const UltimosPedidosTable = () => {
const UltimosPedidosTable: React.FC<Props> = ({ data, loading }: Props) => {
  const columns: ColumnsType<PedidoResumen> = [
    {
      title: "Fecha",
      dataIndex: "Fecha",
      key: "Fecha",
    },
    {
      title: "R",
      dataIndex: "R",
      key: "R",
      align: "center",
    },
    {
      title: "Prov",
      dataIndex: "Prov",
      key: "Prov",
    },
    {
      title: "Cant",
      dataIndex: "Cant",
      key: "Cant",
      align: "right",
    },
    {
      title: "Boni",
      dataIndex: "Boni",
      key: "Boni",
      align: "right",
    },
    {
      title: "Des",
      dataIndex: "Des",
      key: "Des",
      align: "right",
      // render: (value) => `${value.toFixed(2)}%`,
    },
    {
      title: "Costo",
      dataIndex: "Costo",
      key: "Costo",
      align: "right",
      // render: (value) => `$${value.toFixed(2)}`,
    },
  ];

  return (
    <Table
      title={() => <div style={{ textAlign: "left" }}>Ultimas Ordenes de Compras</div>}
      className='custom-table-visor'
      columns={columns}
      scroll={{ x: 50, y: 50 }}
      dataSource={data}
      loading={loading}
      pagination={false}
      bordered
      size='small'
    />
  );
};

export default UltimosPedidosTable;
